import React, { useState } from "react";
// import TextField from '@material-ui/core/TextField';
import Grid from "@material-ui/core/Grid";
// import Box from "@material-ui/core/Box";
import Typography from "@material-ui/core/Typography";
import { makeStyles } from "@material-ui/core/styles";
import Container from "@material-ui/core/Container";
import AppBar from "../../header/index";
// import { Filter, TextInput, Show } from "react-admin";
// import TextField from "@material-ui/core/TextField";
// import CardContent from "@material-ui/core/CardContent";
import SearchIcon from "@material-ui/icons/Search";
// import InputAdornment from "@material-ui/core/InputAdornment";
// import AccountCircle from "@material-ui/icons/AccountCircle";
import Paper from "@material-ui/core/Paper";
import IconButton from "@material-ui/core/IconButton";
// import SignInButton from "../../button/globleButtons";
import AppProvider from "../../bootstrap/index";
import InputBase from "@material-ui/core/InputBase";

// import CancleAppointmentrequest from "./CancleAppointmentRequest";
import { Card } from "@material-ui/core";
// import SearchIcon from '@material-ui/icons/Search';
import Avatar from "@material-ui/core/Avatar";
import CardHeader from "@material-ui/core/CardHeader";
// import { Certificate } from "crypto";
// import SearchBar from 'material-ui-search-bar'
const useStyles = makeStyles(theme => ({
  root: {
    maxWidth: 345
  }
  // inputRoot: {
  //     color: 'inherit',
  //   },
  //   inputInput: {
  //     padding: theme.spacing(1, 1, 1, 0),
  //     // vertical padding + font size from searchIcon
  //     paddingLeft: `calc(1em + ${theme.spacing(4)}px)`,
  //     transition: theme.transitions.create('width'),
  //     width: '100%',
  //     [theme.breakpoints.up('sm')]: {
  //       width: '12ch',
  //       '&:focus': {
  //         width: '20ch',
  //       },
  //     },
  //   },
  // subtext1:{
  //   color:" black",
  //   background: "yellow"
  // },
}));

// const onclick='false';
// const expand=(props)=>{

//   console.log("***Clicked****",props)

//   return(
//     <div>

//     <CancleAppointmentrequest/>
//   </div>
//   );
// }

const Appointmentrequest = props => {
  const [Click] = useState("false");
  const [Clicks] = useState("false");
  console.log("***Props*****", Click);
  console.log("***Props*****", Clicks);
  const classes = useStyles();
  return (
    <div className={classes.coverBackgroundContainer}>
      <Grid item xs={12} sm={6} style={{ marginTop: 60, marginLeft: 10 }}>
        <Paper
          component="form"
          className={classes.root}
          style={{ minWidth: "80%", marginTop: "20%" }}
        >
          <IconButton className={classes.iconButton} aria-label="menu">
            <SearchIcon />
          </IconButton>
          <InputBase
            className={classes.input}
            placeholder="Search Mentor Profile"
            inputProps={{ "aria-label": "search google maps" }}
          />
        </Paper>
      </Grid>
      {/* <Show >
    {/* <Icon  name="ios-search" size={20} color="#000"/> 
    <TextInput label="Search Mentor Profile"  style={{ minWidth: 250 }} source="q" alwaysOn   />

</Show> */}
      <Container component="main" maxWidth="xs">
        <Typography
          component="h6"
          variant="h6"
          style={{ marginTop: "5%", minWidth: "100%", textAlign: "center" }}
        >
          Please Select a Mentor
        </Typography>

        <Card className={classes.root} style={{ marginTop: 15 }}>
          <CardHeader
            avatar={
              <Avatar
                aria-label="recipe"
                className={classes.avatar}
                style={{ height: 50, width: 50 }}
              ></Avatar>
            }
            title="Mario Speedwagoan"
            subtitle="Certification"
            subheader="Certified in Governace of Enterpise IT(CGEITS)"
          />

          {/* <CardContent><Typography className={classes.title} color="textSecondary" gutterBottom>
          Word of the Day
        </Typography></CardContent> */}
        </Card>
        <Card className={classes.root} style={{ marginTop: 15 }}>
          <CardHeader
            avatar={
              <Avatar
                aria-label="recipe"
                className={classes.avatar}
                style={{ height: 50, width: 50 }}
              ></Avatar>
            }
            title="Mario Speedwagoan"
            subtitle="Certification"
            subheader="Certified in Governace of Enterpise IT(CGEITS)"
          />
        </Card>

        <Card className={classes.root} style={{ marginTop: 15 }}>
          <CardHeader
            avatar={
              <Avatar
                aria-label="recipe"
                className={classes.avatar}
                style={{ height: 50, width: 50 }}
              ></Avatar>
            }
            title="Mario Speedwagoan"
            subtitle="Certification"
            subheader="Certified in Governace of Enterpise IT(CGEITS)"
          />
        </Card>

        <AppProvider>
          <AppBar />
        </AppProvider>
      </Container>
    </div>
  );
};
export default Appointmentrequest;
